// extracted by mini-css-extract-plugin
module.exports = {"addSectionButton":"CreateSection_addSectionButton__3vRqA","text":"CreateSection_text__Pfr5g","withBorderBottom":"CreateSection_withBorderBottom__1V3fY"};